import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-4rem flex align-items-center justify-content-between bg-white px-2" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "pl-1 font-medium" }

import Button from "primevue/button";
import TabMenu from "primevue/tabmenu";
import Menu from "primevue/menu";
import { Route } from "@evolutivelabs/quokka-common";
import { config } from "@/config";
import { onBeforeMount, ref } from "vue";
import { useUserStore } from "@/store/user.store";
import { storeToRefs } from "pinia";
import { useAuthStore } from "@/store/auth.store";
import router from "@/router";

type tabMenuItem = { icon: string; label: string; to: Route };


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const QuokkaLogo = config.LOGO;
const authStore = useAuthStore();
const userStore = useUserStore();
const { user } = storeToRefs(userStore);
onBeforeMount(async () => {
  await userStore.fetch();
  if (authStore.isRhinoshield) {
    routes.value.push({
      label: "Devices",
      icon: "pi pi-fw pi-briefcase",
      to: Route.Devices,
    });
  }
});

const menu = ref<InstanceType<typeof Menu>>();
const menuItems = [
  {
    label: "Logout",
    icon: "pi pi-sign-out",
    command: async () => {
      await authStore.logout();
      window.location.reload();
    },
  },
];

const routes = ref<tabMenuItem[]>([
  { label: "Dashboard", icon: "pi pi-fw pi-th-large", to: Route.Dashboard },
  { label: "Targets", icon: "pi pi-fw pi-tags", to: Route.Targets },
]);

function toggleMenu(event: Event) {
  menu.value?.toggle(event);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("img", {
      src: _unref(QuokkaLogo),
      alt: "QuokkaLogo",
      class: "h-full cursor-pointer",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push(_unref(Route).Home)))
    }, null, 8, _hoisted_2),
    _createVNode(_unref(TabMenu), { model: routes.value }, null, 8, ["model"]),
    _createVNode(_unref(Button), {
      onClick: toggleMenu,
      class: "p-button-text p-button-plain px-0 h-full"
    }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          src: _unref(user).picture,
          alt: _unref(user).displayName,
          class: "border-circle h-full"
        }, null, 8, _hoisted_3),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(user).displayName), 1)
      ]),
      _: 1
    }),
    _createVNode(_unref(Menu), {
      ref: (_value, _refs) => {
        _refs['menu'] = _value
        menu.value = _value
      },
      popup: "",
      model: menuItems
    }, null, 512)
  ]))
}
}

})